import { useAppSelector } from "../redux/hooks";
import { Navigate, Outlet } from "react-router-dom";
import reloadAnimation from "../animations/reload.json";
import Lottie from "lottie-react";

export const AdminRoute = () => {
  const { admin, isInitialized } = useAppSelector((state) => state.admin);
  if (!isInitialized) {
    return (
      <div className="w-full h-screen">
        <Lottie
          animationData={reloadAnimation}
          loop={true}
          className="w-full h-full"
        />
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};
